import { render, staticRenderFns } from "./treatment_analysis.vue?vue&type=template&id=5e4e72b5&scoped=true&"
import script from "./treatment_analysis.vue?vue&type=script&lang=js&"
export * from "./treatment_analysis.vue?vue&type=script&lang=js&"
import style0 from "./treatment_analysis.vue?vue&type=style&index=0&id=5e4e72b5&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4e72b5",
  null
  
)

export default component.exports